import React, { useState } from 'react'
import {
  IconShare,
  Radio,
  BlockList,
  TitleSecondary,
  SpacerHorizontal
} from 'mage-deps/@klarna/bubble-ui'
import { Modal } from 'mage-deps/@klarna/mp-ui'
import ButtonRoundPrimary from '@bubble-contrib/molecule-button-round-primary'
import { useHelpContext } from '../hooks'
import { hooks as i18nHooks } from 'mage-i18n'

function getDeepLink(path, parameters) {
  switch (path) {
    case 'article':
      return `${path}:${parameters.articleSlug}`
    case 'topic':
      return `${path}:${parameters.topicSlug}`
    case 'tour':
      return `${path}:${parameters.tourSlug}`
  }
}

function ShareButton() {
  const [showShareModal, setShowShareModal] = useState(false)
  const t = i18nHooks.useTranslator()

  function toggleModal() {
    setShowShareModal(!showShareModal)
  }
  const {
    navigation: {
      activePage: { path, parameters }
    }
  } = useHelpContext()
  const deeplink = getDeepLink(path, parameters)
  const searchParams = new URLSearchParams(location.search)
  searchParams.append('help-page', deeplink)

  return (
    <>
      <SpacerHorizontal small />
      <ButtonRoundPrimary id="uhqm-home-button" size="medium" onPress={toggleModal}>
        <IconShare />
      </ButtonRoundPrimary>
      {showShareModal && (
        <Modal onClose={toggleModal} useWindowHeight={false}>
          <TitleSecondary>{t(`hqm.shareButton.title.${path}`)}</TitleSecondary>
          <Radio
            name="radio"
            defaultValue="home"
            options={[
              {
                description: t('hqm.shareButton.descriptionHome'),
                value: 'home',
                label: t('hqm.shareButton.radioItemHome'),
                content: (
                  <BlockList
                    items={[
                      `https://eu.portal.klarna.com?${searchParams.toString()}`,
                      `https://us.portal.klarna.com?${searchParams.toString()}`,
                      `https://ap.portal.klarna.com?${searchParams.toString()}`
                    ]}
                  />
                )
              },
              {
                description: t('hqm.shareButton.descriptionCurrent'),
                value: 'current',
                label: t('hqm.shareButton.radioItemCurrent'),
                content: (
                  <BlockList
                    items={[
                      `https://eu.portal.klarna.com${location.pathname}?${searchParams.toString()}`,
                      `https://us.portal.klarna.com${location.pathname}?${searchParams.toString()}`,
                      `https://ap.portal.klarna.com${location.pathname}?${searchParams.toString()}`
                    ]}
                  />
                )
              }
            ]}
          />
        </Modal>
      )}
    </>
  )
}

export default ShareButton
